<template>
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header" v-if="header">
            <h4 class="card-title">{{ header }}</h4>
          </template>
          <div v-if="tuning" class="row">
            <div class="col-md-3">
              <p v-on:click="showColumnsSettings = !showColumnsSettings">
                Настройка колонок
                <i v-if="showColumnsSettings" class="tim-icons icon-minimal-up"></i>
                <i v-else class="tim-icons icon-minimal-down"></i>
              </p>
              <div v-if="showColumnsSettings" class="row" style="text-align: left; margin-left: 10px;">
                <p style="margin-right: 20px" v-for="(column, index) in table.columns" :key="index">
                  <base-checkbox v-if="column.header" v-model="column.show">
                    {{column.header}}
                  </base-checkbox>
                </p>
              </div>
            </div>

            <div class="col-md-3">
              <p>
                Записей на странице
                <select name="onpage" v-model="pageSize">
                  <option disabled :value="pageSize">{{ pageSize }}</option>
                  <option v-for="(number, index) in pageSizes" :key="index">{{ number }}</option>
                </select>
              </p>
            </div>

            <div class="col-md-4">
              <p v-on:click="showFilter = !showFilter">
                Настройка фильтров
                <i v-if="showFilter" class="tim-icons icon-minimal-up"></i>
                <i v-else class="tim-icons icon-minimal-down"></i>
              </p>
              <div v-if="!showFilter" class="row">
                <div class="col-md-12">
                  <a v-for="(column, index) in table.columns" :key="index">
                    <a v-if="column.header && column.contains">
                      {{column.header + ': ' + column.contains}}
                      <i class="tim-icons icon-simple-remove" v-on:click="column.contains = ''" style="margin-right: 10px"></i>
                    </a>
                    <a v-if="column.entityValue">
                      {{column.header + ': ' + column.entityValue.name}}
                      <i class="tim-icons icon-simple-remove" v-on:click="column.entityValue = null" style="margin-right: 10px"></i>
                    </a>
                    <a v-if="column.selector">
                      {{column.title + ': ' + getValueNameFromSelectorList(column.selectorList, column.contains)}}
                    </a>
                    <a v-if="column.after">
                      {{column.header + ' после: ' + (column.date ? asDate(column.after) : column.after)}}
                      <i class="tim-icons icon-simple-remove" v-on:click="column.after = null" style="margin-right: 10px"></i>
                    </a>
                    <a v-if="column.before">
                      {{column.header + ' до: ' + (column.date ? asDate(column.before) : column.before)}}
                      <i class="tim-icons icon-simple-remove" v-on:click="column.before = null" style="margin-right: 10px"></i>
                    </a>

                  </a>
                </div>
              </div>
              <div v-if="showFilter" class="row" style="text-align: left; margin-left: 10px;">
                <div class="col-md-12">
                  <div class="row" v-for="(column, index) in table.columns" :key="index">
                    <div class="col-md-12">
                      <base-input v-if="column.header && (column.contains || column.contains === '')" :label="column.header"
                                  v-model="column.contains"
                                  :placeholder="column.contains">
                      </base-input>
                      <items-option v-if="column.entityFilter" :label="column.header" @update="updateEntityFilter"
                                    :object="column.entityValue" :type="'disabledCategory'" :index="index">
                      </items-option>

                      <list-option v-if="column.selector" :label="column.title" :object="column" :field="'contains'"
                                   :name="'name'" :value="'value'" :objects="column.selectorList">
                      </list-option>

                      <div v-if="column.valueFilter">
                        <p>{{column.header}}</p>
                        <div class="row">
                          <div class="col-md-6">
                            <base-input label="После"
                                        v-model="column.after"
                                        :date="true"
                            ></base-input>
                          </div>
                          <div class="col-md-6">
                            <base-input label="До"
                                        v-model="column.before"
                                        :date="true"
                            ></base-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-2">
              <base-button @click="refresh" :size="'sm'" type="success" fill>Применить</base-button>
            </div>

          </div>
          <div v-if="aPage && !hidePages" style="text-align: right; margin-right: 30px;">
            <i v-on:click="previousPage" class="tim-icons icon-minimal-left"></i>
            {{'стр. ' + (page + 1)}}
            <i v-on:click="nextPage" class="tim-icons icon-minimal-right"></i>
          </div>
          <div class="table-responsive text-left">
            <base-table
                        :data="table.data"
                        :columns="table.columns"
                        :headers="table.headers"
                        :sortBy="sortBy"
                        :sortDirection="sortDirection"
                        :type="this.type"
                        :tableClass="'bg-white'"
                        @sort="setSort"
                        @update_top="updateTop"
                        thead-classes="text-primary">
            </base-table>
          </div>
          <div v-if="aPage && !hidePages" style="text-align: right; margin-right: 30px;">
            <i v-on:click="previousPage" class="tim-icons icon-minimal-left"></i>
            {{'стр. ' + (page + 1)}}
            <i v-on:click="nextPage" class="tim-icons icon-minimal-right"></i>
          </div>
        </card>
      </div>

    </div>
</template>
<script>

import {
  BaseInput,
  Card,
  BaseTable
} from "@/components/index";
import {authHeader} from "@/services/auth-header";
import {convertLongToPeriod} from "@/services/periods-service";
import {longAsStringDate} from "@/services/utils";
import ListOption from "@/components/ListOption";

export default{
  props: {
    content: [],
    type: '',
    pageLimits: {},
    defaultValueFilter: {},
    header: null,
    tuning: false,
    newOne: null,
    aPage: false,
    hidePages: false,
    defaultSort: null,
    defaultSortDirection: null,
    objects: null
  },
  components:{
    ListOption,
    Card,
    BaseTable,
    BaseInput
  },
  data() {
    return {
      socket: null,
      table: {
        title: "Список",
        columns: this.content,
        data: []
      },
      page: 0,
      pageSize: 20,
      showColumnsSettings: false,
      showFilter: false,
      pageSizes: [5, 10, 20, 50, 100, 200],
      sortBy: null,
      sortDirection: null,
      dataMap: new Map
    };
  },
  computed: {
    archivedList: function () {
      return this.$repo.getSelector('archived');
    }
  },
  methods: {
    askPage() {
      let pageProperties = {page: this.page, pageSize: this.pageSize, sortBy: this.sortBy,
        sortDirection: this.sortDirection,
        filterMap: this.pageLimits ? this.pageLimits: {},
        valueFilter: this.defaultValueFilter ? this.defaultValueFilter : {}
      };
      this.table.columns.forEach(column => {
        let name = column.name;
        if (column.contains) {
          pageProperties.filterMap[name] = column.contains;
        }
        if (column.entityFilter && column.entityValue) {
          pageProperties.filterMap[column.entityField] = String(column.entityValue.id);
        }
        if (column.valueFilter) {
          pageProperties.valueFilter[name] = {};
          if (column.before) {
            pageProperties.valueFilter[name].before = column.before;
          }
          if (column.after) {
            pageProperties.valueFilter[name].after = column.after;
          }
        }
      })
      return pageProperties;
    },
    async connect() {
      if (this.objects) {
        this.table.data = [];
        this.objects.forEach(item => this.table.data.push({object: item, id: item.id}));
      } else {
        this.table.data = [];
        if (this.aPage) {
          await this.$repo.getPage(this.askPage(), this.table.data, this.type);
        } else {
          if (this.pageLimits) {
            let pageProperties = {
              page: 0, pageSize: 100000, sortBy: this.sortBy, sortDirection: this.sortDirection,
              filterMap: this.pageLimits
            }
            await this.$repo.getPage(pageProperties, this.table.data, this.type);
          } else {
            await this.$repo.getAllHeavy(this.table.data, this.type);
          }
        }
      }
    },
    nextPage() {
      this.page++;
      this.table.data = [];
      this.connect();
    },
    previousPage() {
      if (this.page > 0) {
        this.page--;
        this.table.data = [];
        this.connect();
      }
    },
    setSort(sortBy) {
      this.sortBy = sortBy.name;
      this.sortDirection = sortBy.direction;
      this.refresh();
    },
    refresh() {
      this.page = 0;
      this.showFilter = false;
      this.table.data = [];
      this.connect();
    },
    updateTop() {
      this.$emit('update_top')
    },
    asDate(long) {
      return longAsStringDate(long);
    },
    updateEntityFilter(val, index) {
      this.table.columns[index].entityValue = val;
    },
    getSelectorList(name) {
      return this.$repo.getSelector(name);
    },
    getValueNameFromSelectorList(list, value) {
      let name = '';
      list.forEach(sl => {
        if (sl.value === value) {
          name = sl.name;
        }
      });
      return name;
    }
  },
  async created() {
    this.sortBy = this.defaultSort ? this.defaultSort : 'name';
    this.sortDirection = this.defaultSortDirection ? this.defaultSortDirection : true;
    await this.connect();
  },
  watch: {
    newOne: function (val) {
      if (val) {
        val = JSON.parse(JSON.stringify(val));
        if (this.table.data.length > 0 && this.table.data[0].id === 0) {
          this.table.data.shift();
        }
        this.table.data.unshift(val);
        this.$emit('resetNew');
      }
    },
    objects: function () {
      this.connect();
    }
  }
}
</script>
<style>
</style>
